import { useEffect } from 'react';

import * as Sentry from '@sentry/react';

import { useQueryByEventType } from 'bundles/course-v2/event-management/hooks/useQueryByEventType';

const useHasDayOneOnboardingModalBeenSeen = (skip = false) => {
  const { loading, error, data, refetch } = useQueryByEventType({ eventType: 'DAY_ONE_ONBOARDING_MODAL_SEEN', skip });

  useEffect(() => {
    if (error) {
      Sentry.captureException(error);
    }
  }, [error]);

  const hasBeenSeen = !!error || !!data?.LexExperimentEvents?.queryByEventType?.id || false;

  return {
    loading,
    hasBeenSeen,
    refetch,
  };
};

export default useHasDayOneOnboardingModalBeenSeen;
